/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */


import redirectByName from "@/router/utils/redirectByName.js";

let ScopoMaxMain = () => import(/* webpackChunkName: "AssessmentBuy" */ '@/core/modules/coach/Assessments/Purchase/ScopoMaxMain.vue')
let ScopoMaxWelcome = () => import(/* webpackChunkName: "AssessmentBuy" */ '@/core/modules/coach/Assessments/Purchase/ScopoMaxWelcome.vue')
let ScopoMaxClientList = () => import(/* webpackChunkName: "AssessmentBuy" */ '@/core/modules/coach/Assessments/Purchase/ScopoMaxClientList.vue')
let ScopoMaxSuccess = () => import(/* webpackChunkName: "AssessmentBuy" */ '@/core/modules/coach/Assessments/Purchase/ScopoMaxSuccess.vue')
let AssessmentResults = () => import(/* webpackChunkName: "AssessmentBuy" */ '@/core/modules/coach/Assessments/Take/AssessmentResults.vue')

let AssessmentTakeMain = () => import(/* webpackChunkName: "AssessmentTake" */ '@/core/modules/coach/Assessments/Take/AssessmentTakeMain')
let AssessmentTakeWelcome = () => import(/* webpackChunkName: "AssessmentTake" */ '@/core/modules/coach/Assessments/Take/AssessmentTakeWelcome')
let AssessmentTakeInProgress = () => import(/* webpackChunkName: "AssessmentTake" */ '@/core/modules/coach/Assessments/Take/AssessmentTakeInProgress')
let AssessmentTakeCompleted = () => import(/* webpackChunkName: "AssessmentTake" */ '@/core/modules/coach/Assessments/Take/AssessmentTakeCompleted.vue')

export default [

	{
		path: '/app/scopomax',
		name: 'scopomax',
		redirect: redirectByName('ScopoMaxWelcome'),
		component: ScopoMaxMain,
		props: true,
		meta:{
			isWhitelisted: true
		},
		children: [
			{
				path: 'welcome',
				name: 'ScopoMaxWelcome',
				props: true,
				component: ScopoMaxWelcome,
			},
			{
				path: 'client-list',
				name: 'ScopoMaxClientList',
				props: true,
				component: ScopoMaxClientList,
			},
			{
				path: 'success',
				name: 'ScopoMaxSuccess',
				props: true,
				component: ScopoMaxSuccess,
			},
		]
	},
	{
		path: '/app/assessment/:ownerId/:assessmentId/:assigneeId/take',
		name: 'assessmentTake',
		redirect: redirectByName('AssessmentTakeWelcome'),
		component: AssessmentTakeMain,
		props: true,
		meta:{
			isWhitelisted: true
		},
		children: [
			{
				path: 'welcome',
				name: 'AssessmentTakeWelcome',
				props: true,
				component: AssessmentTakeWelcome,
			},
			{
				path: 'inprogress/:questionIndexProp',
				name: 'AssessmentTakeInProgress',
				props: true,
				component: AssessmentTakeInProgress,
			},
			{
				path: 'completed',
				name: 'AssessmentTakeCompleted',
				props: true,
				component: AssessmentTakeCompleted,
			},
			{
				path: 'coach-report',
				name: 'AssessmentResults',
				props: (route) => ({
					reportOwner: "coach",
					ownerId: route.params.ownerId,
					assessmentId: route.params.assessmentId,
					assigneeId: route.params.assigneeId,
					loadingText: "Preparing your report..."
				}),
				component: AssessmentResults,
			},
			{
				path: 'final-report',
				name: 'AssessmentClientReport',
				props: (route) => ({
					reportOwner: "client",
					ownerId: route.params.ownerId,
					assessmentId: route.params.assessmentId,
					assigneeId: route.params.assigneeId,
					loadingText: "Preparing your report..."
				}),
				component: AssessmentResults,
			},
		]
	},
]
